import * as React from 'react';
import { Item } from 'Components/Grid';
import HistoryRow from 'Components/HistoryRow';
import HistoryRowControls from 'Components/HistoryRowControls';
import HistoryRowListing from 'Components/HistoryRowListing';
import type { IHistoryContext } from 'Containers/FormContextHandler';
import { formatPartialDate } from 'Utility/date';
import { fm } from 'Components/FormatMessage';
import { newButton } from '../../../../utils/functions';
import { filterDocumentsByType } from 'Utility/documentHandling';

const PolyneuroUnderlyingConditionHistory = ({
  documents = [],
  startEdit,
}: IHistoryContext<IPolyneuroUnderlyingCondition>): React.JSX.Element => {
  return (
    <HistoryRow
      headerText={fm('diagnosis.polyneuro.underlyingCondition.title')}
      rowButton={
        startEdit
          ? newButton('polyneuroUnderlyingCondition', startEdit({}, 'polyneuroUnderlyingCondition'), 'general.new', 15)
          : undefined
      }
    >
      <HistoryRowListing
        documents={filterDocumentsByType(documents, ['polyneuroUnderlyingCondition'])}
        headers={
          <>
            <Item xs={2}>{fm('general.date')}</Item>
            <Item xs={6}>{fm('diagnosis.polyneuro.underlyingCondition.icd10')}</Item>
            <Item xs={3} />
          </>
        }
        contentFormat={d => {
          return (
            <>
              <Item xs={2} style={{ paddingRight: 0 }}>
                {formatPartialDate(d.date)}
              </Item>
              <Item xs={6}>
                {d.classification?.icd10code}
                {' - '}
                {d.classification?.icd10description}
              </Item>
            </>
          );
        }}
        collapse={false} // All etiologies should be shown NEUR-4608
        makeControls
        historyRowControls={d => (startEdit ? <HistoryRowControls document={d} startEdit={startEdit} /> : <></>)}
      />
    </HistoryRow>
  );
};

export default PolyneuroUnderlyingConditionHistory;
